import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import { handleError, handleResponse } from "../utils/handleResponses";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import EndpointFunctions from "../utils/Functions/endpointFunctions";
import { message } from "antd";
import Endpoints from "../api/endpoints";
import { useNavigate } from "react-router-dom";
import PageRoutes from "../utils/routes";
import useAuth from "../hooks/useAuth";

const useFirmService = () => {
  const axiosPrivate = useAxiosPrivate();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { setFirmAuth, firmAuth } = useAuth(); // Custom hook for auth state management

  //----- FİRMA İLAN GETLEME EKLEME GÜNCELLEME SİLME FONKSİYONLARI----------//

  //Firma İlan Ekleme
  const useAddAdvert = () => {
    return useMutation({
      mutationFn: async (values) => {
        const response = await EndpointFunctions.postData({
          endpointURL: Endpoints.firmAddAdvert,
          axiosPrivate: axiosPrivate,
          requestBody: values,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("İlan başarıyla Oluşturuldu!");
        queryClient.invalidateQueries(["firm"]);
        navigate(PageRoutes.adverts);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  //Firmanın Bir İlanını Id İle Getleme
  const useGetFirmAdvertById = (id) => {
    return useQuery({
      queryKey: ["firmAdvert", id],
      retry: 3,
      // staleTime: Infinity,
      // cacheTime: Infinity,
      queryFn: async () => {
        const response = await EndpointFunctions.fetchData({
          endpointURL: Endpoints.getFirmAdvertById,
          axiosPrivate: axiosPrivate,
          httpParams: { id: id },
        });
        return handleResponse({ response });
      },
    });
  };

  //Firmanın İlanlarını Getleme
  const useGetFirmAdverts = () => {
    return useMutation({
      mutationFn: async (requestBody) => {
        const response = await EndpointFunctions.postData({
          endpointURL: Endpoints.filterFirmAdverts,
          axiosPrivate: axiosPrivate,
          requestBody: requestBody,
        });
        return handleResponse({ response });
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  //Firma İlan Silme
  const useDeleteFirmAdvert = () => {
    return useMutation({
      mutationFn: async (id) => {
        const response = await EndpointFunctions.deleteRecord({
          endpointURL: Endpoints.deleteFirmAdvert,
          axiosPrivate: axiosPrivate,
          recordId: id,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("İlan başarıyla Silindi!");
        queryClient.invalidateQueries(["firmAdverts"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  //Firma İlan Update
  const useUpdateAdvert = () => {
    return useMutation({
      mutationFn: async (values) => {
        const response = await EndpointFunctions.postData({
          endpointURL: Endpoints.updateFirmAdvert,
          axiosPrivate: axiosPrivate,
          requestBody: values,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("İlan başarıyla Oluşturuldu!");
        queryClient.invalidateQueries(["firm"]);
        navigate(PageRoutes.adverts);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  //Firma İlan Adres Getleme
  const useGetGeoCodingAdress = () => {
    return useMutation({
      mutationFn: async (values) => {
        const response = await EndpointFunctions.fetchData({
          endpointURL: Endpoints.getAdressGeoCoding,
          axiosPrivate: axiosPrivate,
          httpParams: values,
        });
        return handleResponse({ response });
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  //Firma Kayıtlı Adresleri Getleme
  const useGetSavedLocation = () => {
    return useQuery({
      queryKey: ["savedLocation"],
      // staleTime: Infinity,
      // cacheTime: Infinity,
      queryFn: async () => {
        const response = await EndpointFunctions.fetchData({
          endpointURL: Endpoints.getSavedLocations,
          axiosPrivate: axiosPrivate,
        });
        return handleResponse({ response });
      },
      select: (data) => {
        console.log("data");
        return (
          data?.data.map((location) => ({
            value: location.id,
            label: `${location.address}${
              location.district?.name
                ? ` (${location.district.name} / ${location.district.city?.name})`
                : location.city?.name
                ? ` (${location.city.name})`
                : location.country?.name
                ? ` (${location.country.name})`
                : ""
            }`,
          })) || []
        );
      },
    });
  };

  //----- FİRMA BİLGİLERİ GETİRME GÜNCELLEME FONKSİYONLARI----------//

  //Firma Bilgilerini Getleme
  const useGetFirm = () => {
    return useQuery({
      queryKey: ["firm"],
      staleTime: Infinity,
      cacheTime: Infinity,
      queryFn: async () => {
        const response = await EndpointFunctions.fetchData({
          endpointURL: Endpoints.getFirmInfo,
          axiosPrivate: axiosPrivate,
        });
        return handleResponse({ response });
      },
      //   select: (data) => {
      //     const selectOptions = data.data.map((item) => {
      //       const key = Object.keys(item)[0];
      //       const value = item[key];

      //       return { label: value, value: key };
      //     });
      //     return selectOptions;
      //   },
    });
  };

  //Firma Kullanıcısını Id İle Getleme
  const useGetFirmUserById = (id) => {
    return useQuery({
      queryKey: ["firmUser", id],
      queryFn: async () => {
        const response = await EndpointFunctions.fetchData({
          endpointURL: Endpoints.getFirmUserByUserId,
          axiosPrivate: axiosPrivate,
          httpParams: {
            id: id,
          },
        });
        return handleResponse({ response });
      },
    });
  };

  //Firma Bilgilerini Getleme
  const useGetFirmUsers = () => {
    return useQuery({
      queryKey: ["firmUsers"],
      staleTime: Infinity,
      cacheTime: Infinity,
      queryFn: async () => {
        const response = await EndpointFunctions.fetchData({
          endpointURL: Endpoints.getFirmUsers,
          axiosPrivate: axiosPrivate,
        });
        return handleResponse({ response });
      },
    });
  };

  //Firma Bilgilerini Updateleme
  const useUpdateFirm = () => {
    return useMutation({
      mutationFn: async (values) => {
        const response = await EndpointFunctions.postData({
          endpointURL: Endpoints.updateFirm,
          axiosPrivate: axiosPrivate,
          requestBody: values,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Firma Bilgileri başarıyla güncellendi!");
        queryClient.invalidateQueries(["firm"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  //Firma Resmini Updateleme
  const useUploadFirmImage = () => {
    return useMutation({
      mutationFn: async (file) => {
        const formData = new FormData();
        formData.append("image", file);
        const response = await EndpointFunctions.postData({
          endpointURL: Endpoints.addFirmImage,
          formData: formData,
          axiosPrivate: axiosPrivate,

          isMultiPart: true,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Fotoğraf başarıyla yüklendi!");
        queryClient.invalidateQueries(["firm"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  //Firma Google Sign-In Sonrası Bilgileri Tamamlama
  const useCompleteFirmInformation = () => {
    return useMutation({
      mutationFn: async (requestBody) => {
        const response = await EndpointFunctions.postData({
          endpointURL: Endpoints.completeFirmInformation,
          axiosPrivate: axiosPrivate,
          requestBody: requestBody,
        });
        return handleResponse({ response });
      },
      onSuccess: (data) => {
        message.success("Firma Bilgileri Başarı İle Kaydedildi");
        const firm = data.data;
        setFirmAuth({ ...firmAuth, user: { ...firmAuth.user, firm } });
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  //----- FİRMA KULLANICISI EKLEME GÜNCELLEME SİLME FONKSİYONLARI----------//
  const useCreateFirmUser = () => {
    return useMutation({
      mutationFn: async (requestBody) => {
        const response = await EndpointFunctions.postData({
          endpointURL: Endpoints.createFirmUser,
          requestBody: requestBody,
          axiosPrivate: axiosPrivate,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Kullanıcı başarıyla eklendi!");
        queryClient.invalidateQueries(["firm"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useUpdateFirmUser = () => {
    return useMutation({
      mutationFn: async (requestBody) => {
        const response = await EndpointFunctions.postData({
          endpointURL: Endpoints.updateFirmUser,
          axiosPrivate: axiosPrivate,
          requestBody: requestBody,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Firma Kullanıcıs başarıyla güncellendi!");
        queryClient.invalidateQueries(["firm"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  const useDeleteFirmUser = () => {
    return useMutation({
      mutationFn: async (id) => {
        const response = await EndpointFunctions.deleteRecord({
          endpointURL: Endpoints.deletePersonnelExperience,
          axiosPrivate: axiosPrivate,
          recordId: id,
        });
        return handleResponse({ response });
      },
      onSuccess: () => {
        message.success("Deneyim başarıyla silindi!");
        queryClient.invalidateQueries(["personnel"]);
      },
      onError: (error) => {
        message.error(handleError({ error }).errorMessage);
      },
    });
  };

  //----- FİRMA BAŞVURAN CVPREVIEW VE CVPREVIEWPDF GETLEME FONKSİYONLARI----------//
  const useGetCvPreview = () => {
    return useMutation({
      mutationKey: ["cvPreview"],
      mutationFn: async (personnelId) => {
        const response = await EndpointFunctions.fetchData({
          endpointURL: Endpoints.getCvPreviewFirm,
          axiosPrivate: axiosPrivate,
          httpParams: { personnelId: personnelId },
        });
        return handleResponse({ response });
      },
    });
  };

  const useGetCvPreviewPdf = () => {
    return useMutation({
      mutationKey: ["cvPreviewPdf"],
      mutationFn: async (personnelId) => {
        const response = await EndpointFunctions.fetchData({
          endpointURL: Endpoints.getCvPreviewPdfFirm,
          axiosPrivate: axiosPrivate,
          httpParams: { personnelId: personnelId },
        });
        return handleResponse({ response });
      },
    });
  };

  return {
    useCreateFirmUser,
    useUpdateFirmUser,
    useDeleteFirmUser,
    useGetFirm,
    useGetFirmUsers,
    useGetFirmUserById,
    useUpdateFirm,
    useUploadFirmImage,
    useAddAdvert,
    useGetFirmAdverts,
    useGetFirmAdvertById,
    useDeleteFirmAdvert,
    useUpdateAdvert,
    useGetGeoCodingAdress,
    useGetSavedLocation,
    useGetCvPreview,
    useGetCvPreviewPdf,
    useCompleteFirmInformation,
  };
};

export default useFirmService;
